import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _get from "@babel/runtime-corejs3/helpers/get";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = _Reflect$construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
import { getMessageProp } from "@jutro/platform";
import { OldFieldComponentValidationImplementation } from "../FieldComponent/OldFieldComponentValidationImplementation";
import { isFileOfAllowedType } from "./mimeTypes";
import { messages } from "./FileUploadField.messages";
export var OldFileUploadFieldValidationImplementation = function (_OldFieldComponentVal) {
  _inherits(OldFileUploadFieldValidationImplementation, OldFieldComponentValidationImplementation);
  var _super = _createSuper(OldFileUploadFieldValidationImplementation);
  function OldFileUploadFieldValidationImplementation() {
    return _classCallCheck(this, OldFileUploadFieldValidationImplementation), _super.apply(this, arguments);
  }
  return _createClass(OldFileUploadFieldValidationImplementation, [{
    key: "bind",
    value: function (entityToBind) {
      var _this = this,
        superBoundMethods = _get(_getPrototypeOf(OldFileUploadFieldValidationImplementation.prototype), "bind", this).call(this, entityToBind),
        methods = ["getValidationMessages", "handleChange", "handleClearValue"];
      return _reduceInstanceProperty(methods).call(methods, function (acc, method) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, method, _this[method].bind(entityToBind)));
      }, superBoundMethods);
    }
  }, {
    key: "componentDidUpdate",
    value: function (prevProps, prevState) {
      var prevErrorMessageState = prevState.errorMessage,
        errorMessageState = this.state.errorMessage;
      this.handleErrorStateChange(prevErrorMessageState, errorMessageState), _get(_getPrototypeOf(OldFileUploadFieldValidationImplementation.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
    }
  }, {
    key: "handleChange",
    value: function (e, isMultipleFileUpload, multipleErrorMessages) {
      var _e$target$value,
        _e$dataTransfer,
        _e$dataTransfer$files,
        _e$dataTransfer2,
        _this$props = this.props,
        maxLength = _this$props.maxLength,
        onUpload = _this$props.onUpload,
        accept = _this$props.accept,
        messageProps = _this$props.messageProps,
        maxFileSizeKB = _this$props.maxFileSizeKB,
        incorrectFileTypeMessage = getMessageProp("incorrectFileTypeMessage", messageProps, messages),
        maxFileSizeKBMessage = getMessageProp("maxFileSizeKBMessage", messageProps, messages),
        maxLengthMessage = getMessageProp("maxLengthMessage", messageProps, messages);
      if (this.pristine = !1, this.focusPristine = !1, isMultipleFileUpload) return this.setState({
        errorMessage: null != multipleErrorMessages && multipleErrorMessages.length ? multipleErrorMessages : void 0
      }), void this.notifyChange(_mapInstanceProperty(e).call(e, function (file) {
        return file.name;
      }));
      var errorMessage,
        path = null !== (_e$target$value = e.target.value) && void 0 !== _e$target$value ? _e$target$value : null === (_e$dataTransfer = e.dataTransfer) || void 0 === _e$dataTransfer ? void 0 : _e$dataTransfer.files[0].name,
        file = null !== (_e$dataTransfer$files = null === (_e$dataTransfer2 = e.dataTransfer) || void 0 === _e$dataTransfer2 ? void 0 : _e$dataTransfer2.files[0]) && void 0 !== _e$dataTransfer$files ? _e$dataTransfer$files : e.target.files[0];
      (e.target.value = null, maxLength && file && file.name.length > maxLength && (errorMessage = this.translator(maxLengthMessage, {
        nameLength: maxLength
      })), accept && file) && (isFileOfAllowedType(file, accept) || (errorMessage = this.translator(incorrectFileTypeMessage)));
      maxFileSizeKB && file && file.size > 1e3 * maxFileSizeKB && (errorMessage = this.translator(maxFileSizeKBMessage, {
        fileSizeKB: maxFileSizeKB,
        fileSize: 1e3 * maxFileSizeKB
      })), this.setState({
        errorMessage: errorMessage
      }), this.notifyChange(path), file && !errorMessage && (null == onUpload || onUpload(file));
    }
  }, {
    key: "getValidationMessages",
    value: function (progressErrorMessage, isFileValidationMessage) {
      if (this.props.value && !isFileValidationMessage) return [];
      var errorMessage = this.state.errorMessage;
      return errorMessage ? progressErrorMessage ? [progressErrorMessage] : [errorMessage] : progressErrorMessage ? [progressErrorMessage] : _get(_getPrototypeOf(OldFileUploadFieldValidationImplementation.prototype), "getValidationMessages", this).call(this);
    }
  }, {
    key: "handleClearValue",
    value: function () {
      this.state.errorMessage && this.setState({
        errorMessage: void 0
      }), this.notifyChange(void 0);
    }
  }]), OldFileUploadFieldValidationImplementation;
}();